import '../scss/main.scss';


window.$ = jQuery;


import 'slick-carousel'


$(".people-carousel >div").slick({

    // normal options...
    infinite: true,

    arrows: false,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 800,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }

        },
        {
            breakpoint: 550,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }

        },
    ]

});


$(document).on('click', '#about-read-more', (e) => {
    e.preventDefault();

    $('#read-more-text').toggle('fast')

    if (!$('#about-read-more').hasClass('open')) {
        $('#about-read-more').text('Close').addClass('open').css('background')
    } else {
        $('#about-read-more').text('Read More').removeClass('open')
    }


    return false
})

$(document).on('click', '.mobile-package-dropdown > button', function (e) {

    let button = $(this),
        collapseParent = button.parents('.mobile-package-dropdown'),
        collapse = collapseParent.find('.mobile-collapse')

    collapseParent.toggleClass('open')


    if (collapseParent.hasClass('open')) {
        collapse.slideDown('fast')
        let offset = $('#wpadminbar').outerHeight()??0
        $([document.documentElement, document.body]).animate({
            scrollTop: collapseParent.offset().top - $('#main-nav').outerHeight() -offset -10
        }, 800);
    } else {
        collapse.slideUp('fast')
    }

})

$(document).on('click', '.person-profile .et_pb_button', function (e) {
    let button = $(this),
        id = button.data('id'),
        readMore = $(`.person-read-mores .person-read-more[data-id="${id}"]`)

    $('.person-profile .et_pb_button').not(button).removeClass('open').text('Read More')
    $(`.person-read-mores .person-read-more`).not(readMore).slideUp('fast')

    $('person-read-mores')

    if (!button.hasClass('open')) {
        button.text('Close').addClass('open')
        readMore.slideDown('fast', function () {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(`.person-read-mores .person-read-more[data-id="${id}"]`).offset().top - $('#main-nav').outerHeight() - 50
            }, 600);
        })

    } else {
        button.text('Read More').removeClass('open')
        readMore.slideUp('fast')
    }

})
